// src/components/game/StartScreen.jsx
import React, { useState } from 'react';
import { getAvatar, ASSETS } from '../../utils/GameAssets';

const PROFESSIONS = ['Logistics', 'Medical', 'Banking', 'Mining', 'Oil & Gas', 'Pilot & ATC', 'Aestheticians', 'Legal', 'Hospitality', 'Cabin Crew', 'Young Genius', 'Dream Achiever'];
const COUNTRIES = [{ id: 'Canada', label: 'Canada' }, { id: 'UK', label: 'United Kingdom' }, { id: 'USA', label: 'USA' }, { id: 'Australia', label: 'Australia' }, { id: 'NewZealand', label: 'New Zealand' }];

export default function StartScreen({ dispatch }) {
  const [name, setName] = useState('');
  const [profession, setProfession] = useState('Logistics');
  const [gender, setGender] = useState('Female'); 
  const [country, setCountry] = useState('Canada');

  const handleStart = () => {
    if (!name) { alert("Enter name"); return; }
    const avatarPath = getAvatar(profession, gender);
    dispatch({ 
        type: 'SET_PROFILE', 
        payload: { name, profession, gender, targetCountry: country, avatar: avatarPath } 
    });
  };

  const currentAvatar = getAvatar(profession, gender);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center p-4 md:p-10 bg-black relative overflow-hidden">
        <div className="absolute inset-0 z-0"><img src={ASSETS.STILLS.StartScreen} className="w-full h-full object-cover opacity-60" alt="bg" /></div>
        <div className="absolute inset-0 bg-black/70 z-0"></div>
        
        <div className="relative z-10 flex flex-col md:flex-row gap-12 items-center max-w-6xl w-full">
            
            {/* LEFT COLUMN: AVATAR PREVIEW */}
            <div className="flex-1 flex flex-col items-center justify-center">
                <div className="w-80 h-[500px] border-4 border-yellow-600 rounded-lg overflow-hidden shadow-[0_0_50px_rgba(234,179,8,0.2)] bg-black mb-6 relative">
                    <img 
                        src={currentAvatar} 
                        alt="Agent Avatar" 
                        // THE FIX: 'object-cover' fills the box (no black bars). 
                        // 'object-top' ensures the HEAD is always visible.
                        className="w-full h-full object-cover object-top relative z-10"
                        onError={(e) => {e.target.style.display='none'}} 
                    />
                </div>
                <div className="bg-black/60 px-6 py-2 rounded border border-yellow-600/50">
                    <h2 className="text-3xl text-yellow-500 font-bold uppercase tracking-widest">{profession}</h2>
                    <p className="text-gray-400 text-xs mt-1 uppercase tracking-[0.2em]">Class: Specialist</p>
                </div>
            </div>

            {/* RIGHT COLUMN: CONTROLS */}
            <div className="flex-1 w-full bg-gray-900/90 p-10 rounded-xl border border-gray-600 shadow-2xl backdrop-blur-md">
                <h1 className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-yellow-500 mb-2">AUTARKY</h1>
                <p className="text-gray-400 text-xs tracking-[0.3em] mb-10">INITIATING AGENT PROTOCOL v3.0</p>

                <div className="space-y-6 text-left">
                    <div>
                        <label className="text-xs text-gray-500 uppercase font-bold ml-1">Agent Name</label>
                        <input type="text" placeholder="ENTER IDENTIFIER" value={name} onChange={e => setName(e.target.value)} className="w-full p-4 bg-black text-white border border-gray-600 focus:border-yellow-500 rounded outline-none transition-all font-mono text-lg" />
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="text-xs text-gray-500 uppercase font-bold ml-1">Profession</label>
                            <select value={profession} onChange={e => setProfession(e.target.value)} className="w-full p-4 bg-black text-white border border-gray-600 focus:border-yellow-500 rounded outline-none cursor-pointer">
                                {PROFESSIONS.map(p => <option key={p} value={p}>{p}</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="text-xs text-gray-500 uppercase font-bold ml-1">Gender</label>
                            <select value={gender} onChange={e => setGender(e.target.value)} className="w-full p-4 bg-black text-white border border-gray-600 focus:border-yellow-500 rounded outline-none cursor-pointer">
                                <option value="Female">Female</option>
                                <option value="Male">Male</option>
                            </select>
                        </div>
                    </div>

                    <div>
                        <label className="text-xs text-gray-500 uppercase font-bold ml-1">Target Jurisdiction</label>
                        <select value={country} onChange={e => setCountry(e.target.value)} className="w-full p-4 bg-black text-white border border-gray-600 focus:border-yellow-500 rounded outline-none cursor-pointer">
                            {COUNTRIES.map(c => <option key={c.id} value={c.id}>{c.label}</option>)}
                        </select>
                    </div>

                    <button onClick={handleStart} className="w-full bg-red-700 hover:bg-red-600 py-5 font-bold text-xl mt-8 text-white rounded shadow-[0_0_20px_rgba(220,38,38,0.5)] transition-all transform hover:scale-[1.02] tracking-widest">
                        BEGIN SIMULATION
                    </button>
                </div>
            </div>
        </div>
    </div>
  );
}